import { createAxiosInstance } from './createAxiosInstance';

const axiosInstance = createAxiosInstance(import.meta.env.REACT_APP_PAYMENT_URL);

export default axiosInstance;
